import { AxiosError, AxiosResponse } from 'axios'
import { QualificationQuestionsResponse } from '../../dtos/QualificationQuestions'
import { http } from '../Http'
import QualificationQuestionsDataSource from '../dataSource/QualificationQuestionsDataSource'

export default class QualificationQuestionsMapper
  implements QualificationQuestionsDataSource
{
  async getQualificationQuestions(): Promise<QualificationQuestionsResponse> {
    let data = await http
      .get<QualificationQuestionsResponse>(`send_data/qualification_questions`)
      .then((response: AxiosResponse) => {
        const { data } = response
        return data
      })
      .catch((error: AxiosError) => {
        const data: QualificationQuestionsResponse = {
          statusCode: error.response?.status as number,
          body: error.response?.statusText as string,
          headers: {
            'Access-Control-Allow-Headers': '',
            'Access-Control-Allow-Origin': '',
            'Access-Control-Allow-Methods': ''
          }
        }
        return data
      })
    return data
  }
}
